"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputWrapperDefaultProps = void 0;
var _interfaces = require("../../_form/interfaces");
var _utils = require("../../utils");
const inputWrapperDefaultProps = exports.inputWrapperDefaultProps = {
  error: false,
  warning: false,
  required: false,
  shouldValidateNonInclusiveTerms: false,
  labelPosition: _interfaces.LabelPosition.Top,
  labelSpacing: _utils.LABEL_SPACING
};